export enum UserType {        
    Recruiter = 1,
    Candidate = 2
}